import React, { useEffect } from "react";
import { isAuthenticated, removeItem } from "../auth";
import { FiDelete, FiAlertTriangle } from "react-icons/fi";
import Unavailable from '../Layout/icon/Unavailable.png';
import Empty from '../Layout/icon/Empty.png';
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["cardCartAvailable"]?.[key] || fallback;

const urlFilter = (filter) => {
    let texFil = "";
    for (let fil in filter) {
        texFil += fil + "=" + filter[fil] + "&";
    }
    return "?" + texFil;
};

const CardCartAvailable = ({ product, cartItems, infoSource }) => {
    __setElakayInfoSource(infoSource);

    const { token } = isAuthenticated();
    const CartID = product.cartID;

    // Styles avec animations
    const styles = {
        card: {
            background: 'linear-gradient(135deg, #ffffff 0%, #fef9c3 100%)',
            borderRadius: '14px',
            border: '2px solid #fbbf24',
            minHeight: '134px',
            marginBottom: '1rem',
            padding: '1rem',
            position: 'relative',
            boxShadow: '0 4px 12px rgba(251, 191, 36, 0.2)',
            overflow: 'hidden',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
        warningBanner: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            background: 'linear-gradient(135deg, #fef3c7 0%, #fde047 100%)',
            padding: '0.65rem 1rem',
            borderTopLeftRadius: '14px',
            borderTopRightRadius: '14px',
            fontSize: '0.875rem',
            fontWeight: '600',
            color: '#92400e',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            boxShadow: '0 2px 4px rgba(251, 191, 36, 0.2)',
            transition: 'all 0.3s ease',
        },
        contentWrapper: {
            marginTop: '2.5rem',
            display: 'flex',
            gap: '1rem',
        },
        imageCell: {
            flexShrink: 0,
            width: '120px',
            height: '120px',
            position: 'relative',
            borderRadius: '10px',
            overflow: 'hidden',
            border: '1px solid #fde047',
            background: 'linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%)',
            transition: 'transform 0.3s ease',
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'grayscale(100%) opacity(0.4)',
        },
        unavailableOverlay: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '70%',
            zIndex: 2,
            transition: 'transform 0.3s ease',
        },
        unavailableImage: {
            width: '100%',
            height: 'auto',
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
        },
        contentCell: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '0.5rem',
        },
        productInfo: {
            color: '#92400e',
            fontSize: '0.9375rem',
            fontWeight: '500',
            margin: 0,
        },
        productMessage: {
            color: '#78716c',
            fontSize: '0.8125rem',
            margin: 0,
        },
        deleteButton: {
            padding: '0.5rem',
            background: 'linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)',
            border: '1px solid #fee2e2',
            borderRadius: '10px',
            color: '#ef4444',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            fontSize: '1.25rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'flex-start',
            boxShadow: '0 2px 4px rgba(239, 68, 68, 0.1)',
        },
    };

    // Animations CSS - UNIQUEMENT AU HOVER
    const animationStyles = `
/* Animation d'entrée : UNE SEULE FOIS */
@keyframes unavailableSlideIn {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Shake : UNIQUEMENT AU HOVER */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-3px); }
}

/* Bounce icône : UNIQUEMENT AU HOVER */
@keyframes iconBounce {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.15);
  }
}

.card-unavailable {
  animation: unavailableSlideIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) both;
}

/* HOVER sur la card entière */
.card-unavailable:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(251, 191, 36, 0.35);
  border-color: #f59e0b;
}

/* Banner pulse : UNIQUEMENT AU HOVER */
.card-unavailable:hover .warning-banner-animated {
  animation: shake 0.5s ease;
  background: linear-gradient(135deg, #fde047 0%, #facc15 100%);
  box-shadow: 0 4px 8px rgba(251, 191, 36, 0.3);
}

/* Image scale : UNIQUEMENT AU HOVER */
.card-unavailable:hover .unavailable-image-cell {
  transform: scale(1.05);
}

/* Icône bounce : UNIQUEMENT AU HOVER */
.card-unavailable:hover .unavailable-overlay-animated {
  animation: iconBounce 0.6s ease;
}

@media (max-width: 768px) {
  .unavailable-content-wrapper {
    flex-direction: column;
  }
  
  .unavailable-image-cell {
    width: 100%;
    height: 150px;
  }
}

/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .card-unavailable,
  .warning-banner-animated,
  .unavailable-overlay-animated {
    animation: none !important;
    transition: none !important;
  }
}
`;

    // Inject animations
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.textContent = animationStyles;
        document.head.appendChild(styleSheet);
        return () => {
            if (document.head.contains(styleSheet)) {
                document.head.removeChild(styleSheet);
            }
        };
    }, []);

    const deleteCart = (token, c, p) => {
        removeItem(token, { "count": c, "CartID": p }).then(data => {
            if (!data) {
            } else {
                cartItems(token);
            }
        });
    };

    let urlFil = urlFilter(product.filterPro?.filter || {});

    const buttonDeleteCart = () => {
        deleteCart(token, 0, CartID);
    };

    return (
        <div 
            className="card-unavailable" 
            style={styles.card}
        >
            {/* Warning Banner */}
            <div className="warning-banner-animated" style={styles.warningBanner}>
                <FiAlertTriangle size={18} />
                <span>{__elakayText("t005", "Ce produit n'est plus disponible")}</span>
            </div>

            {/* Content */}
            <div className="unavailable-content-wrapper" style={styles.contentWrapper}>
                {/* Image */}
                <a 
                    href={product._id && `/product/preview/${product.publicId || product._id}${urlFil}`}
                    style={{ textDecoration: 'none' }}
                >
                    <div className="unavailable-image-cell" style={styles.imageCell}>
                        <img
                            src={Empty}
                            alt={__elakayText("t006", "Produit indisponible")}
                            style={styles.image}
                        />
                        <div className="unavailable-overlay-animated" style={styles.unavailableOverlay}>
                            <img
                                src={Unavailable}
                                alt={__elakayText("t009", "Indisponible")}
                                style={styles.unavailableImage}
                            />
                        </div>
                    </div>
                </a>

                {/* Info */}
                <div style={styles.contentCell}>
                    <p style={styles.productInfo}>
                        {product.name || elakayAutoText("h_4a0672e481da13", "Produit indisponible")}
                    </p>
                    <p style={styles.productMessage}>{__elakayText("t007", "Ce produit a été retiré ou n'est plus en stock")}</p>
                </div>

                {/* Delete Button */}
                <button
                    style={styles.deleteButton}
                    onClick={buttonDeleteCart}
                    onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.15) rotate(8deg)";
                        e.target.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1) rotate(0deg)";
                        e.target.style.boxShadow = "0 2px 4px rgba(239, 68, 68, 0.1)";
                    }}
                    aria-label={__elakayText("t008", "Supprimer du panier")}
                >
                    <FiDelete />
                </button>
            </div>
        </div>
    );
};

export default CardCartAvailable;